// Import the functions you need from the SDKs you need
import { FirebaseApp, initializeApp } from "firebase/app";
import { Firestore, getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDiq1yg6hsnpiAEG__npfVFTHnkfd55SK8",
  authDomain: "archire-27998.firebaseapp.com",
  projectId: "archire-27998",
  storageBucket: "archire-27998.firebasestorage.app",
  messagingSenderId: "202992686865",
  appId: "1:202992686865:web:4bf84c41cdbf03b4955eb0",
};

const app: FirebaseApp = initializeApp(firebaseConfig);
export const db: Firestore = getFirestore(app);
